import { getEndpointV2 } from 'api';
import { fillPath } from 'helpers/api';
import { Params, TripInfo } from 'types';

export const getInfoPath = (id: string, info: TripInfo, params?: Params): string => {
  return fillPath({
    path: '/tripmanage/trips/:id/invoice/:info',
    urlParams: { id, info },
    params,
  });
};

export const getInfoUrl = (id: string, info: TripInfo, params?: Params): string => {
  return getEndpointV2({
    path: getInfoPath(id, info, params),
  });
};

export const getSwapUrl = (id: string, info: TripInfo, params?: Params): string => {
  return getEndpointV2({
    path: '/tripmanage/trips/:id/invoice/:info/swap',
    urlParams: { id, info },
    params,
  });
};

export const getCreateStepValidationsUrl = (
  id: string,
  info: TripInfo,
  params?: Params
): string => {
  return getEndpointV2({
    path: '/tripmanage/trips/:id/invoice/:info/validate',
    urlParams: { id, info },
    params,
  });
};
